export function validNum(v: number | null | undefined) {
  return v || v === 0
}
